import { render, staticRenderFns } from "./problemManage.vue?vue&type=template&id=e50355e2&scoped=true&"
import script from "./problemManage.vue?vue&type=script&lang=js&"
export * from "./problemManage.vue?vue&type=script&lang=js&"
import style0 from "./problemManage.vue?vue&type=style&index=0&id=e50355e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50355e2",
  null
  
)

export default component.exports